export const PAYOR_MASTER_LOOKUP_GOVERNMENT_TYPE = 'Government';
export const PAYOR_MASTER_LOOKUP_CASH_TYPE = 'Cash';
export const PAYOR_MASTER_LOOKUP_COMMERCIAL_TYPE = 'Commercial';
export const PAYOR_MASTER_LOOKUP_UNDETERMINED_TYPE = 'Undetermined';
export const PAYOR_MASTER_LOOKUP_NONELIGIBLE = 'Noneligible';
export const PAYOR_MASTER_LOOKUP_MEDICARE = 'Medicare';
export const PAYOR_MASTER_LOOKUP_MANUFACTURER_SPONSORED_TYPE = 'Manufacturer Sponsored';
export const PAYOR_MASTER_LOOKUP_COMINGLED_TYPE = 'Comingled';

const sharedMasterDataPayorMasterLookupTypesAsConst = [
  PAYOR_MASTER_LOOKUP_GOVERNMENT_TYPE,
  PAYOR_MASTER_LOOKUP_CASH_TYPE,
  PAYOR_MASTER_LOOKUP_COMMERCIAL_TYPE,
  PAYOR_MASTER_LOOKUP_UNDETERMINED_TYPE,
  PAYOR_MASTER_LOOKUP_NONELIGIBLE,
  PAYOR_MASTER_LOOKUP_MEDICARE,
  PAYOR_MASTER_LOOKUP_MANUFACTURER_SPONSORED_TYPE,
  PAYOR_MASTER_LOOKUP_COMINGLED_TYPE,
] as const;

export const SHARED_MASTER_DATA_PAYOR_MASTER_LOOKUP_TYPES = [...sharedMasterDataPayorMasterLookupTypesAsConst];

export type SharedMasterDataPayorMasterLookupType = (typeof sharedMasterDataPayorMasterLookupTypesAsConst)[number];
